var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#DBE7FF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_813_173464)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_813_173464",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_813_173464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.999 14.7917C11.874 14.7917 11.756 14.7708 11.6449 14.7292C11.5337 14.6875 11.4296 14.6181 11.3324 14.5208L8.26986 11.4583C8.0893 11.2778 7.99902 11.0556 7.99902 10.7917C7.99902 10.5278 8.0893 10.3056 8.26986 10.125C8.43652 9.95833 8.65513 9.87167 8.92569 9.865C9.1968 9.85778 9.42263 9.9375 9.60319 10.1042L11.0407 11.5625V5.8125C11.0407 5.54861 11.1346 5.32639 11.3224 5.14583C11.5096 4.96528 11.7351 4.875 11.999 4.875C12.2629 4.875 12.4885 4.96528 12.6757 5.14583C12.8635 5.32639 12.9574 5.54861 12.9574 5.8125V11.5625L14.3949 10.1042C14.5754 9.9375 14.8012 9.85778 15.0724 9.865C15.3429 9.87167 15.5615 9.95833 15.7282 10.125C15.9087 10.3056 15.999 10.5278 15.999 10.7917C15.999 11.0556 15.9087 11.2778 15.7282 11.4583L12.6657 14.5208C12.5685 14.6181 12.4643 14.6875 12.3532 14.7292C12.2421 14.7708 12.124 14.7917 11.999 14.7917ZM6.89486 18.9792C6.36708 18.9792 5.9193 18.795 5.55152 18.4267C5.18319 18.0589 4.99902 17.6111 4.99902 17.0833V15.2292C4.99902 14.9653 5.09291 14.7431 5.28069 14.5625C5.46791 14.3819 5.69347 14.2917 5.95736 14.2917C6.22125 14.2917 6.44347 14.3819 6.62402 14.5625C6.80458 14.7431 6.89486 14.9653 6.89486 15.2292V17.0833H17.0824V15.2292C17.0824 14.9653 17.1762 14.7431 17.364 14.5625C17.5512 14.3819 17.7768 14.2917 18.0407 14.2917C18.3046 14.2917 18.5268 14.3819 18.7074 14.5625C18.8879 14.7431 18.9782 14.9653 18.9782 15.2292V17.0833C18.9782 17.6111 18.794 18.0589 18.4257 18.4267C18.0579 18.795 17.6101 18.9792 17.0824 18.9792H6.89486Z",
    fill: "#3676F5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_813_173464"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBlue);
export default __webpack_public_path__ + "static/media/download-blue.58cf340926c9490b5ee1fa1505704078.svg";
export { ForwardRef as ReactComponent };